import Marquee from "react-fast-marquee";
import { MARQUEE_ITEMS } from "@/data/content";

const EditorialMarquee = ({ dark = false }) => (
  <div
    data-testid="editorial-marquee"
    className={`border-y overflow-hidden py-6 ${
      dark ? "bg-ink border-ivory/10" : "bg-ivory border-navy/10"
    }`}
  >
    <Marquee speed={35} gradient={false} pauseOnHover>
      {MARQUEE_ITEMS.map((item) => (
        <span key={item} className="flex items-center">
          <span
            className={`font-serif italic text-2xl md:text-3xl font-light px-8 ${
              dark ? "text-ivory/80" : "text-navy/80"
            }`}
          >
            {item}
          </span>
          <span className="text-gold text-[8px]">◆</span>
        </span>
      ))}
    </Marquee>
  </div>
);

export default EditorialMarquee;
